import React, {useEffect, useState} from 'react';
import { useRef } from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, Button, Container, Badge, UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from 'axios';
import * as url from "../../helpers/url_helper"
import { HRConfig, TOAST_OPTIONS } from 'helpers/backend_helper';

import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { useHistory } from 'react-router-dom';
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
} from "react-bootstrap-table2-paginator";

    const RecruitmentApplicants = () => {
      const history = useHistory()
        const [aList, setAList] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        useEffect(()=>{
            axios.get(`${url.APPLICANTS}`, HRConfig).then((r)=>{
                setAList(r.data.value)
            }).catch((e)=>{
                console.log(e)
            })
        },[])
         //pagination customization
    const pageOptions = {
        sizePerPage: 20,
        totalSize: aList.length, // replace later with size(orders),
        custom: true,
    };
    var node = useRef();
             

      const { SearchBar } = Search;
      const columns = [
        {
            dataField: 'ApplicantNo',
            text: 'No',
            sort: true,
            formatter: noFormatter
        }, 
        {
            dataField: 'FirstName',
            text: 'Name',
            sort: true,
            formatter: nameFormatter
          },
          {
            dataField: 'sex',
            text: 'Gender',
            sort: true
            
          }, 
          {
            dataField: 'phoneNo',
            text: 'Contacts',
            sort: true,
            formatter: contactsFormatter
          }, 
     
      {
        dataField: 'ApplicationSubmitted',
        text: '',
        sort: true,
        formatter: statusFormatter
      }, 
 
      {
        dataField: "action",
        isDummyField: true,
        text: "",
        formatter: actionFormatter
      }];

      const defaultSorted = [{
        dataField: 'patientID',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <>{cellContent}</>
        )
      }
      function nameFormatter(cellContent, row){
        return(
          <>{row.FirstName}<br/>{row.MiddleName} {row.LastName}</>
        )
      }
      function contactsFormatter(cellContent, row){
        return(
          <>{row.MobilePhoneNo}<br/>{row.EMail}<br/>{row.Address2}</>
        )
      }
      function statusFormatter(cellContent, row){
        if (!row.ApplicationSubmitted) {
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { `Not Submitted` }
                  </Badge>
              </div>
            );

        }else{
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { `Submitted` }
                  </Badge>
              </div>
            );
        }
      }
      function actionFormatter(cellContent, row){
        return(
          <Button
            type="button"
            color="info"
            className="btn-sm btn-rounded"
            onClick={()=>{ history.push(`/applicant-details/${row.SystemId}`)}}
          >
            Details
          </Button>
           
          )
      }
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Applicants | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Applicants" />
                        <Row>
          

          <Col lg={12}>
            <Card>
              <CardBody>
                 {aList && (aList.length > 0) && (

                  <PaginationProvider
                  pagination={paginationFactory(pageOptions)}
                  keyField="ApplicantNo"
                  columns={columns}
                  data={aList}
                >
                  {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                    keyField="ApplicantNo"
                    data={ aList }
                    columns={ columns }
                    search
                  >
                    { toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                          <Col lg={8}>
                                  <div  className="rounded bg-light d-grid gap-2">
                                    <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                  </div>
                              </Col>
                            <Col sm="3">
                           
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              
                          
                              <BootstrapTable 
                                keyField='ApplicantNo' 
                                data={ aList } 
                                columns={ columns } 
                                striped
                                hover
                                condensed
                                bordered={ false }
                                noDataIndication="No Records" 
                                defaultSorted={ defaultSorted }
                                classes={ "table-sm align-middle table-check" }
                                  {...toolkitProps.baseProps}
                                //onTableChange={handleTableChange}
                                  {...paginationTableProps}
                                ref={node}
                                />
                           
                           </Col>
                           </Row>
                           <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                              <PaginationListStandalone
                                {...paginationProps}
                              />
                            </Col>
                          </Row>
                           </React.Fragment>
                          
                    )
                  }
                </ToolkitProvider>
                )}
                </PaginationProvider>
                )}
                {aList && (aList.length < 1) && (
                  <div className="text-center">
                    <div className="mb-4">
                    <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                    </div>
                    <div>
                    { isLoading ? <h5>Please Wait...</h5> : <h5>No Applicant Found Yet</h5> }
                    <p className="text-muted">
                            
                    </p>
                    </div>
                </div>

                )}
              </CardBody>
            </Card>
          </Col>

          

        </Row>

                           

                    </Container>
                </div>
            </>
        );
    }

export default RecruitmentApplicants;